<template>
  <ListDetailLayout
      :filter="params.filter"
      :store="permissionsStore"
      create-permissions="create:permissions"
      index-route-name="admin.users.permissions"
      @on-create="disabled()"
      @on-paginate="(page) => useOnPaginate(page, refreshPermissions, params)"
      @on-search="(page) => useOnSearch(page, refreshPermissions, params)"
      @on-filter="({ filter }) => useOnFilter(filter, refreshPermissions, params)"
  >

    <template #list>
      <li v-for="permission in permissionsStore.getPermissions" :key="permission.id">
        <router-link v-slot="{isActive}"
                     :to="{ name: 'admin.users.permissions.permission', params: { permission: permission.id } }">
          <div
              :class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

            <div class="min-w-0">
              <div class="flex items-start gap-x-3">
                <p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">
                  {{ permission.display_name }}</p>
              </div>
              <div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
                <p class="whitespace-nowrap">
                  {{ permission.name }}
                </p>
              </div>
            </div>

          </div>
        </router-link>
      </li>
    </template>

    <template #detail>
      <router-view v-if="$route.params.permission" @on-save="refreshPermissions"
                   @on-delete="refreshPermissions"></router-view>
    </template>

  </ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import {mapStores} from "pinia";
import {usePermissionsStore} from "@/stores/permissions.js";
import {useOnFilter, useOnPaginate, useOnSearch} from "@/Composables/Pagination.js";

export default {
  name: "PermissionsIndex",
  data() {
    return {
      params: {
        filter: {
          role_ids: [],
        }
      }
    }
  },
  methods: {
    useOnFilter,
    useOnSearch,
    useOnPaginate,
    refreshPermissions() {
      return this.permissionsStore.indexPermissions(this.params);
    },
    
		disabled() {
			alert('This action is disabled for data integrity and testing reasons. Please contact a developer if you need to create new permissions.');
		},
  },
  components: {Container, ListDetailLayout},
  computed: {
    ...mapStores(usePermissionsStore)
  },
  async mounted() {
    await this.refreshPermissions()
  }
}
</script>